import React from 'react';
const emptyIcon = 'fas';
const Empty = () => /*#__PURE__*/React.createElement("span", {
  className: emptyIcon,
  style: {
    width: '19px'
  }
});
export default Empty;